// extracted by mini-css-extract-plugin
export default {"container":"VkM5g","icon":"_05i4O","text":"zLbK1","name":"AvC5t","description":"pth2Y","skeleton-progress":"VVc80"};